import React from "react";

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404</h1>
      <h3>Page Not Found</h3>
      <p>The restaurant you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;